import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['Tu hijo explota o se bloquea y no sabés qué hacer en ese momento', 'Querés hablar con él/ella pero cada conversación termina en pelea o silencio', 'Ves que las redes lo/la afectan pero no tenés cómo abordarlo sin que se ponga defensivo/a', 'La ansiedad y el estrés escolar están ahí y no tenés un protocolo claro para ayudar', 'Siente que no encaja, que no vale, que todos están mejor que él/ella — y no sabés qué decir', 'Como docente, ves crisis emocionales en el aula y no tenés herramientas concretas para intervenir', 'El fin de semana pasa y el lunes todo vuelve a empezar igual'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden" data-id="element-197">
      {/* Decorative elements — reduced blur on mobile */}
      <div className="absolute -left-40 top-20 w-96 h-96 bg-red-500/5 rounded-full blur-[60px] md:blur-3xl pointer-events-none" data-id="element-198" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12" data-id="element-200">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white" data-id="element-201">
            ¿Cuántos días más vas a pasar{' '}
            <span className="text-red-400" data-id="element-202">sin saber cómo ayudar?</span>
          </h2>

          <p className="text-lg md:text-xl text-slate-300 mb-4 leading-relaxed" data-id="element-203">
            Querés acompañar a tu hijo o a tus alumnos. Los amás. Pero nadie te
            enseñó cómo hablar de emociones sin que se cierren, cómo manejar una
            crisis sin explotar vos también, o cómo ayudarlos a tomar decisiones
            sin que sientan que los controlás.
          </p>

          <div className="inline-block bg-red-500/10 border border-red-500/20 text-red-300 font-semibold px-6 py-3 rounded-lg text-lg mt-4" data-id="element-204">
            No es falta de amor. Es falta de herramientas.
          </div>
        </motion.div>

        <div className="bg-navy-800 border border-navy-700 rounded-2xl p-6 md:p-10 shadow-xl" data-id="element-205">
          <ul className="space-y-6" data-id="element-206">
            {painPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            delay: index * 0.04,
            duration: 0.3
          }} className="flex items-start gap-4" data-id="element-207">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-208" />
                <span className="text-slate-200 text-lg" data-id="element-209">{point}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="text-center mt-16" data-id="element-210">
          <h3 className="text-2xl md:text-3xl font-bold text-gradient-blue" data-id="element-211">
            ¿Y si hoy fuera el último día que pasás sin saber cómo ayudar?
          </h3>
        </motion.div>
      </div>
    </section>;
}